import React, { useEffect } from 'react';
import { useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import PropTypes from 'prop-types';
import {validateAccount} from "../../redux/actions/actionValidate";
import {processUrl} from "../../services/utils";

export const ValidateRegister = (props) => {
  const { history } = props;

  const query = new URLSearchParams(useLocation().search);

  const dispatch = useDispatch();
  const language = useSelector((state) => state.app.language);
  useEffect(function () {
    const value = processUrl(query, "p1");
    value ? dispatch(validateAccount({ accountUUID: value, history, language })) : history.push('/not-found');
  });

  return (
    <React.Fragment>
    </React.Fragment>
  );
}

ValidateRegister.propTypes = {
  history: PropTypes.object
};





